module.exports = __webpack_public_path__ + "img/console.70418500.jpg";